var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigPaperBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.767517 3.16234C1.04918 2.55196 1.90866 2.09357 3.62761 1.1768C5.17979 0.348969 5.95588 -0.064945 6.58933 0.0167557C7.1422 0.0880629 7.64022 0.386876 7.96331 0.841145C8.3335 1.36163 8.3335 2.24119 8.3335 4.00033C8.3335 5.75946 8.3335 6.63902 7.96331 7.15951C7.64022 7.61377 7.1422 7.91259 6.58933 7.98389C5.95588 8.0656 5.17979 7.65168 3.62761 6.82385C1.90866 5.90708 1.04918 5.44869 0.767517 4.83831C0.522156 4.30659 0.522156 3.69406 0.767517 3.16234Z",
    fill: "#FF7A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigPaperBack);
export default __webpack_public_path__ + "static/media/jobconfig-paper-back.c89dd66d1f6271c00d3ff595ace45208.svg";
export { ForwardRef as ReactComponent };